import { Sprite } from '../assets/Sprite.js';
import { parseEmojiToken } from '../assets/keys.js';

/**
 * Art for a speaker, chapter or monster: the bot's original image when the
 * artwork pack provides it, else its emoji, else a generated creature.
 */
export function Portrait({ emoji, image, element, size, boss = false }: { emoji: string; image?: string; element?: string; size: number; boss?: boolean }) {
  const parsed = parseEmojiToken(emoji);
  return (
    <Sprite
      asset={{ kind: 'emoji', id: parsed?.id ?? emoji, name: parsed?.name ?? '', animated: parsed?.animated ?? false }}
      image={image}
      element={element}
      size={size}
      boss={boss}
      decorative
    />
  );
}
